import { UserInfoFI } from "@/components/HolderForm/UserInfoFI.ts";
import { UserInfoFormValues } from "@/components/HolderForm/UserInfoFormValues.ts";
import { CarrierInfoInput } from "@/helpers/types/types.ts";

export const getCarrierInfoInput = (reservationHolderData: UserInfoFormValues): CarrierInfoInput => {
  const carrier: CarrierInfoInput = {
    address: reservationHolderData[UserInfoFI.Address],
    city: reservationHolderData[UserInfoFI.City],
    countryIso: reservationHolderData[UserInfoFI.Country],
    email: reservationHolderData[UserInfoFI.Email],
    firstName: reservationHolderData[UserInfoFI.FirstName],
    lastName: reservationHolderData[UserInfoFI.LastName],
    phoneNumber: reservationHolderData[UserInfoFI.Phone],
    postalCode: reservationHolderData[UserInfoFI.PostalCode],
  };

  if (reservationHolderData[UserInfoFI.CompanyName]) {
    carrier.companyInfo = {
      name: reservationHolderData[UserInfoFI.CompanyName],
      vatId: reservationHolderData[UserInfoFI.CompanyVAT],
      address: reservationHolderData[UserInfoFI.CompanyAddress],
      countryIso: reservationHolderData[UserInfoFI.CompanyCountry],
    };
  }

  return carrier;
};
